import dot from 'dot-prop-immutable';
import { pathOr } from 'ramda';

import { PAGE_REQUEST } from 'store/app/actions';

import { types } from './actions';

const initialState = {
  editingTasks: {},
  newTaskAssignment: {
    assignedUserFullName: null,
    assignedUserId: null,
    dueDate: null,
  },
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case PAGE_REQUEST:
      return {
        ...initialState,
      };
    case types.EDIT_TASK_ERROR:
    case types.EDIT_TASK_SUCCESS:
      return {
        ...state,
        editingTasks: dot.set(state.editingTasks, payload.taskId, false),
      };
    case types.EDIT_TASK_REQUEST:
      return {
        ...state,
        editingTasks: dot.set(state.editingTasks, payload.taskId, true),
      };
    case types.TASK_ASSIGNMENT_RESET:
      return dot.merge(state, 'newTaskAssignment', {
        assignedUserFullName: null,
        assignedUserId: null,
        dueDate: null,
      });
    case types.TASK_ASSIGNMENT_SET:
      return dot.merge(state, 'newTaskAssignment', {
        assignedUserFullName: payload.assignedUserFullName,
        assignedUserId: payload.assignedUserId,
        dueDate: payload.dueDate,
      });
    default:
      return state;
  }
};

const getScope = (state) => state.modules.common.chat.tasks;

const getNewTaskAssignmentScope = (state) => getScope(state).newTaskAssignment;

export const getIsEditingTask = (state, taskId) =>
  pathOr(false, ['editingTasks', taskId], getScope(state));

export const getTaskAssignmentUserFullName = (state) =>
  getNewTaskAssignmentScope(state).assignedUserFullName;

export const getTaskAssignmentUserId = (state) =>
  getNewTaskAssignmentScope(state).assignedUserId;

export const getTaskAssignmentDueDate = (state) =>
  getNewTaskAssignmentScope(state).dueDate;

export default reducer;
